"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const StorefrontCMSPage_1 = __importDefault(require("./StorefrontCMSPage"));
const client_1 = require("@apollo/client");
const MapmakerApi_1 = require("../../client/MapmakerApi");
(0, client_1.gql) `
  query termsOfService {
    storefrontShop {
      termsOfService {
        title
        body
      }
    }
  }
`;
function TermsOfServicePage() {
    const { data, loading } = (0, MapmakerApi_1.useTermsOfServiceQuery)();
    return ((0, jsx_runtime_1.jsx)(StorefrontCMSPage_1.default, { page: data === null || data === void 0 ? void 0 : data.storefrontShop.termsOfService, loading: loading }));
}
exports.default = TermsOfServicePage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGVybXNPZlNlcnZpY2VQYWdlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvcG9saWNpZXMvVGVybXNPZlNlcnZpY2VQYWdlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSw0RUFBMEM7QUFDMUMsMkNBQXFDO0FBQ3JDLDBEQUFrRTtBQUVsRSxJQUFBLFlBQUcsRUFBQTs7Ozs7Ozs7O0NBU0YsQ0FBQztBQUVGLFNBQXdCLGtCQUFrQjtJQUN4QyxNQUFNLEVBQUUsSUFBSSxFQUFFLE9BQU8sRUFBRSxHQUFHLElBQUEsb0NBQXNCLEdBQUUsQ0FBQztJQUNuRCxPQUFPLENBQ0wsdUJBQUMsMkJBQU8sSUFBQyxJQUFJLEVBQUUsSUFBSSxhQUFKLElBQUksdUJBQUosSUFBSSxDQUFFLGNBQWMsQ0FBQyxjQUFjLEVBQUUsT0FBTyxFQUFFLE9BQU8sR0FBSSxDQUN6RSxDQUFDO0FBQ0osQ0FBQztBQUxELHFDQUtDIn0=